module.exports = __webpack_public_path__ + "img/map-marker-orange.4c6a6728.svg";